import React, { useCallback, useEffect, useState } from 'react';
import DeviceData from 'drivers/deviceData';
import Route from 'enum/route.enum';
import { Navigate } from 'react-router-dom';
import { Container, Header } from 'components/styles/Common.styled';
import BackCursor from 'components/common/nav/backCursor';

/**
 * Legacy /casting route — redirects to first available HDMI or shows first port.
 * Prefer /hdmi/:port from the landing menu.
 */
function Casting() {
  const [redirectBack, setRedirectBack] = useState(false);

  const exitCasting = useCallback(async function () {
    await DeviceData.castingHide();
    setRedirectBack(true);
  }, []);

  useEffect(function () {
    DeviceData.castingShow();

    async function onKeyPress(event) {
      const tvKeyControls = await DeviceData.getTVControl();
      if (event.keyCode === tvKeyControls.KEY_BACK) {
        event.preventDefault();
        await exitCasting();
      }
    }

    window.addEventListener('keydown', onKeyPress);

    return function () {
      window.removeEventListener('keydown', onKeyPress);
      DeviceData.castingHide();
    };
  }, [exitCasting]);

  if (redirectBack) {
    return <Navigate to={Route.route.LANDING} />;
  }

  return (
    <div>
      <Header />
      <BackCursor />
      <Container />
    </div>
  );
}

export default Casting;
